import { types, actions } from './requests'
export const GETMACHINELIST_TYPES = {
    ...types('GETMACHINELIST'),
}
export const GETMACHINELIST_ACTIONS = {
    ...actions('GETMACHINELIST'),
}
